<template>
    <div class="content">
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="3" @click="back"><img class="back-icon" :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)"></van-col>
                    <van-col span="18">
                        <div class="banner-title">{{ $t('importMp3.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="top-box">
            {{ $t('importMp3.p1') }}<br>
            {{ $t('importMp3.p2') }}
        </div>
        <div class="title">{{ $t('importMp3.title1') }}</div>
        <div class="p1">{{ $t('importMp3.p3') }}</div>
        <div class="p2">{{ $t('importMp3.p4') }}</div>
        <img class="img" src="@/assets/theme/light/article/importMp3/p1.png">
        <div class="p2">{{ $t('importMp3.p5') }}</div>
        <img class="img" src="@/assets/theme/light/article/importMp3/p2.png">
        <div class="p1">{{ $t('importMp3.p6') }}</div>
        <div class="p2">{{ $t('importMp3.p7') }}</div>
        <img class="img" src="@/assets/theme/light/article/importMp3/p3.png">
        <div class="p2">{{ $t('importMp3.p8') }}</div>
        <img class="img" src="@/assets/theme/light/article/importMp3/p4.png">
        <div class="title">{{ $t('importMp3.title2') }}</div>
        <div class="p1">{{ $t('importMp3.p9') }}</div>
        <div class="p2">{{ $t('importMp3.p10') }}</div>
        <img class="img" src="@/assets/theme/light/article/importMp3/p1.png">
        <div class="p2">{{ $t('importMp3.p11') }}</div>
        <img class="img" src="@/assets/theme/light/article/importMp3/p5.png">
        <div class="p2">{{ $t('importMp3.p12') }}</div>
        <img class="img" src="@/assets/theme/light/article/importMp3/p6.png">
        <div class="p2">{{ $t('importMp3.p13') }}</div>
        <div class="p2">{{ $t('importMp3.p14') }}</div>
        <img class="img" src="@/assets/theme/light/article/importMp3/p3.png">
        <div class="p2">{{ $t('importMp3.p15') }}</div>
        <img class="img" src="@/assets/theme/light/article/importMp3/p7.png">
    </div>
</template>

<script>
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: 'importMp3',
    data() {
        return {
            theme: 'light',
        }
    },
    mounted() {
        if (this.$route.query.theme) {
            this.theme = this.$route.query.theme
        }
    },
    methods: {
        back() {
            WebJSBridge.call("closeWeb", null, function (res) {
            });
        }
    }
}
</script>

<style scoped>
.content {
    width: 100%;
    height: 100%;
    background: var(--bg-color-2) !important;
    padding-top: 0;
    padding-bottom: 20px;
}
.top-box {
    width: 317px;
    background: var(--bg-color-1);
    border-radius: 13px 13px 13px 13px;
    margin: 88px auto 16px;
    font-size: 11px;
    font-family: PP;
    padding: 12px 13px;
    line-height: 15px;
}

.banner {
    background-color: var(--bg-color-2) !important;
}

.title {
    font-size: 15px;
    color: var(--chart-color-1);
    margin-left: 8px;
}

.p1 {
    font-size: 13px;
    margin: 12px 16px;
    line-height: 18px;
}

.p2 {
    font-size: 13px;
    margin: 12px 16px 12px 37px;
    line-height: 18px;
}

.img {
    width: 237px;
    margin-left: 58px;
}
</style>


// WEBPACK FOOTER //
// src/views/article/importMp3.vue